import type { FieldDataType } from "@/types/dynamic-detail";

/**
 * Whether the field's own `options` are its list: a non-empty list, or any list (even empty) when
 * there is no `options_url` to fetch — a list served by the server (`form-step` overrides) that has
 * nothing to offer is « nothing to choose », never « fetch the whole referential ».
 */
export function hasStaticOptions(field: Pick<FieldDataType, "options" | "options_url">): boolean {
    return Array.isArray(field.options) && (field.options.length > 0 || !field.options_url);
}
